import paths from "@ingka/icons-shared/paths/visibility-show";
import { renderPaths } from "../renderPaths.mjs";
var visibility_show_default = () => renderPaths(paths);
export {
  visibility_show_default as default
};
